/**
 * Inline sample datasets for the Physiology & Biochemistry analyses (Phase 1).
 * Pure in-memory JS — no external fetches.
 */

export const PHYSIO_INLINE_SAMPLES = {
  // 1. Crop growth analysis — 4 treatments × 5 dates × 3 reps (wheat biomass/LA)
  'physio-crop-growth': `Treatment,Sampling_date_or_DAS,Fresh_weight_g,Dry_weight_g,Leaf_area_cm2,Ground_area_m2,Rep
Control,30,12.5,2.1,180,1,1
Control,30,12.8,2.2,185,1,2
Control,30,12.6,2.15,182,1,3
Control,45,38.2,7.2,580,1,1
Control,45,39.5,7.4,590,1,2
Control,45,38.8,7.3,585,1,3
Control,60,85.6,18.5,1250,1,1
Control,60,87.2,18.9,1275,1,2
Control,60,86.5,18.7,1262,1,3
Control,75,142.8,32.5,1450,1,1
Control,75,145.2,33.1,1475,1,2
Control,75,143.5,32.8,1460,1,3
Control,90,178.5,45.8,1320,1,1
Control,90,180.2,46.2,1340,1,2
Control,90,179.4,46.0,1330,1,3
Drought,30,10.2,1.8,145,1,1
Drought,30,10.5,1.85,148,1,2
Drought,30,10.3,1.82,146,1,3
Drought,45,28.5,5.8,420,1,1
Drought,45,29.2,5.95,430,1,2
Drought,45,28.8,5.85,425,1,3
Drought,60,58.2,13.2,820,1,1
Drought,60,59.5,13.5,830,1,2
Drought,60,58.8,13.3,825,1,3
Drought,75,95.6,22.8,980,1,1
Drought,75,97.2,23.2,995,1,2
Drought,75,96.4,23.0,988,1,3
Drought,90,118.5,30.2,890,1,1
Drought,90,120.2,30.8,905,1,2
Drought,90,119.4,30.5,898,1,3
Irrigated,30,13.8,2.4,200,1,1
Irrigated,30,14.1,2.45,205,1,2
Irrigated,30,13.9,2.42,202,1,3
Irrigated,45,42.5,8.2,650,1,1
Irrigated,45,43.8,8.4,665,1,2
Irrigated,45,43.0,8.3,658,1,3
Irrigated,60,98.5,21.2,1380,1,1
Irrigated,60,100.2,21.6,1405,1,2
Irrigated,60,99.4,21.4,1392,1,3
Irrigated,75,165.2,38.5,1580,1,1
Irrigated,75,168.0,39.2,1600,1,2
Irrigated,75,166.5,38.8,1590,1,3
Irrigated,90,210.5,54.2,1450,1,1
Irrigated,90,213.2,54.8,1470,1,2
Irrigated,90,211.8,54.5,1460,1,3
Fertilised,30,13.2,2.3,195,1,1
Fertilised,30,13.5,2.35,198,1,2
Fertilised,30,13.3,2.32,196,1,3
Fertilised,45,40.8,7.8,620,1,1
Fertilised,45,42.0,8.0,635,1,2
Fertilised,45,41.2,7.9,625,1,3
Fertilised,60,92.5,20.1,1330,1,1
Fertilised,60,94.2,20.5,1355,1,2
Fertilised,60,93.4,20.3,1342,1,3
Fertilised,75,155.8,36.2,1520,1,1
Fertilised,75,158.5,36.8,1540,1,2
Fertilised,75,157.0,36.5,1530,1,3
Fertilised,90,198.2,51.5,1400,1,1
Fertilised,90,200.8,52.0,1420,1,2
Fertilised,90,199.5,51.8,1410,1,3`,

  // 2. Photosynthesis & gas exchange — 6 genotypes × 3 stages × 3 reps wheat
  'physio-photosynthesis': `Genotype_or_Treatment,Rep,Growth_stage,SPAD_value,Net_photosynthesis_umol_CO2_m2s,Stomatal_conductance_mol_H2O_m2s,Transpiration_mmol_H2O_m2s,Intercellular_CO2_umol_mol,Yield
HD2967,1,Tillering,42.5,22.5,0.35,4.2,265,4.85
HD2967,2,Tillering,43.1,23.1,0.36,4.3,262,4.85
HD2967,3,Tillering,42.8,22.8,0.355,4.25,263,4.85
HD2967,1,Booting,48.2,28.5,0.42,5.1,258,4.85
HD2967,2,Booting,48.8,29.1,0.43,5.2,255,4.85
HD2967,3,Booting,48.5,28.8,0.425,5.15,256,4.85
HD2967,1,Grain_fill,45.2,25.2,0.38,4.7,260,4.85
HD2967,2,Grain_fill,45.8,25.8,0.39,4.8,258,4.85
HD2967,3,Grain_fill,45.5,25.5,0.385,4.75,259,4.85
PBW343,1,Tillering,38.5,18.5,0.28,3.5,275,3.95
PBW343,2,Tillering,39.1,19.1,0.29,3.6,272,3.95
PBW343,3,Tillering,38.8,18.8,0.285,3.55,273,3.95
PBW343,1,Booting,42.2,22.5,0.34,4.2,270,3.95
PBW343,2,Booting,42.8,23.1,0.35,4.3,267,3.95
PBW343,3,Booting,42.5,22.8,0.345,4.25,268,3.95
PBW343,1,Grain_fill,40.2,20.2,0.31,3.9,272,3.95
PBW343,2,Grain_fill,40.8,20.8,0.32,4.0,269,3.95
PBW343,3,Grain_fill,40.5,20.5,0.315,3.95,270,3.95
DBW17,1,Tillering,45.5,25.5,0.38,4.5,260,5.25
DBW17,2,Tillering,46.1,26.1,0.39,4.6,257,5.25
DBW17,3,Tillering,45.8,25.8,0.385,4.55,258,5.25
DBW17,1,Booting,51.2,32.5,0.46,5.5,252,5.25
DBW17,2,Booting,51.8,33.1,0.47,5.6,249,5.25
DBW17,3,Booting,51.5,32.8,0.465,5.55,250,5.25
DBW17,1,Grain_fill,48.2,28.5,0.42,5.0,255,5.25
DBW17,2,Grain_fill,48.8,29.1,0.43,5.1,252,5.25
DBW17,3,Grain_fill,48.5,28.8,0.425,5.05,253,5.25
WH1105,1,Tillering,40.5,20.5,0.32,3.8,270,4.25
WH1105,2,Tillering,41.1,21.1,0.33,3.9,267,4.25
WH1105,3,Tillering,40.8,20.8,0.325,3.85,268,4.25
WH1105,1,Booting,45.2,24.5,0.37,4.6,264,4.25
WH1105,2,Booting,45.8,25.1,0.38,4.7,261,4.25
WH1105,3,Booting,45.5,24.8,0.375,4.65,262,4.25
WH1105,1,Grain_fill,42.5,22.0,0.34,4.2,267,4.25
WH1105,2,Grain_fill,43.1,22.6,0.35,4.3,264,4.25
WH1105,3,Grain_fill,42.8,22.3,0.345,4.25,265,4.25
PBW725,1,Tillering,46.2,26.2,0.39,4.6,258,5.45
PBW725,2,Tillering,46.8,26.8,0.4,4.7,255,5.45
PBW725,3,Tillering,46.5,26.5,0.395,4.65,256,5.45
PBW725,1,Booting,52.5,33.8,0.48,5.7,250,5.45
PBW725,2,Booting,53.1,34.4,0.49,5.8,247,5.45
PBW725,3,Booting,52.8,34.1,0.485,5.75,248,5.45
PBW725,1,Grain_fill,49.2,29.5,0.44,5.2,253,5.45
PBW725,2,Grain_fill,49.8,30.1,0.45,5.3,250,5.45
PBW725,3,Grain_fill,49.5,29.8,0.445,5.25,251,5.45
HD3086,1,Tillering,41.5,21.5,0.33,4.0,268,4.55
HD3086,2,Tillering,42.1,22.1,0.34,4.1,265,4.55
HD3086,3,Tillering,41.8,21.8,0.335,4.05,266,4.55
HD3086,1,Booting,46.8,25.8,0.39,4.8,263,4.55
HD3086,2,Booting,47.4,26.4,0.4,4.9,260,4.55
HD3086,3,Booting,47.1,26.1,0.395,4.85,261,4.55
HD3086,1,Grain_fill,44.2,23.2,0.36,4.5,265,4.55
HD3086,2,Grain_fill,44.8,23.8,0.37,4.6,262,4.55
HD3086,3,Grain_fill,44.5,23.5,0.365,4.55,263,4.55`,

  // 3. Water relations — 8 genotypes × 3 stress levels (Control, Mild, Severe) × 3 reps chickpea
  'physio-water-relations': `Treatment_or_Genotype,Stress_level,Rep,Relative_water_content_percent,Leaf_water_potential_MPa,Osmotic_potential_MPa,Turgor_potential_MPa,Membrane_stability_index_percent,Electrolyte_leakage_percent,Yield
Pusa362,Control,1,92.5,-0.4,-1.2,0.8,85,12,2.1
Pusa362,Control,2,92.8,-0.42,-1.22,0.8,84.5,12.5,2.1
Pusa362,Control,3,92.6,-0.41,-1.21,0.8,84.8,12.2,2.1
Pusa362,Mild,1,78.5,-0.8,-1.5,0.7,78,18,1.75
Pusa362,Mild,2,78.8,-0.82,-1.52,0.7,77.5,18.5,1.75
Pusa362,Mild,3,78.6,-0.81,-1.51,0.7,77.8,18.2,1.75
Pusa362,Severe,1,62.5,-1.4,-1.8,0.4,65,32,1.25
Pusa362,Severe,2,62.8,-1.42,-1.82,0.4,64.5,32.5,1.25
Pusa362,Severe,3,62.6,-1.41,-1.81,0.4,64.8,32.2,1.25
BG256,Control,1,93.2,-0.38,-1.15,0.77,87,11,2.25
BG256,Control,2,93.5,-0.4,-1.17,0.77,86.5,11.5,2.25
BG256,Control,3,93.3,-0.39,-1.16,0.77,86.8,11.2,2.25
BG256,Mild,1,82.5,-0.7,-1.4,0.7,82,15,2.0
BG256,Mild,2,82.8,-0.72,-1.42,0.7,81.5,15.5,2.0
BG256,Mild,3,82.6,-0.71,-1.41,0.7,81.8,15.2,2.0
BG256,Severe,1,72.5,-1.1,-1.6,0.5,74,22,1.6
BG256,Severe,2,72.8,-1.12,-1.62,0.5,73.5,22.5,1.6
BG256,Severe,3,72.6,-1.11,-1.61,0.5,73.8,22.2,1.6
JG11,Control,1,91.5,-0.43,-1.25,0.82,83,13,2.0
JG11,Control,2,91.8,-0.45,-1.27,0.82,82.5,13.5,2.0
JG11,Control,3,91.6,-0.44,-1.26,0.82,82.8,13.2,2.0
JG11,Mild,1,75.5,-0.85,-1.55,0.7,75,20,1.6
JG11,Mild,2,75.8,-0.87,-1.57,0.7,74.5,20.5,1.6
JG11,Mild,3,75.6,-0.86,-1.56,0.7,74.8,20.2,1.6
JG11,Severe,1,58.5,-1.5,-1.85,0.35,60,38,1.0
JG11,Severe,2,58.8,-1.52,-1.87,0.35,59.5,38.5,1.0
JG11,Severe,3,58.6,-1.51,-1.86,0.35,59.8,38.2,1.0
ICC4958,Control,1,93.8,-0.36,-1.1,0.74,88,10,2.35
ICC4958,Control,2,94.1,-0.38,-1.12,0.74,87.5,10.5,2.35
ICC4958,Control,3,93.9,-0.37,-1.11,0.74,87.8,10.2,2.35
ICC4958,Mild,1,85.5,-0.65,-1.35,0.7,85,13,2.15
ICC4958,Mild,2,85.8,-0.67,-1.37,0.7,84.5,13.5,2.15
ICC4958,Mild,3,85.6,-0.66,-1.36,0.7,84.8,13.2,2.15
ICC4958,Severe,1,78.5,-1.0,-1.55,0.55,78,18,1.85
ICC4958,Severe,2,78.8,-1.02,-1.57,0.55,77.5,18.5,1.85
ICC4958,Severe,3,78.6,-1.01,-1.56,0.55,77.8,18.2,1.85
L550,Control,1,90.5,-0.45,-1.3,0.85,82,14,1.95
L550,Control,2,90.8,-0.47,-1.32,0.85,81.5,14.5,1.95
L550,Control,3,90.6,-0.46,-1.31,0.85,81.8,14.2,1.95
L550,Mild,1,73.5,-0.9,-1.6,0.7,72,22,1.55
L550,Mild,2,73.8,-0.92,-1.62,0.7,71.5,22.5,1.55
L550,Mild,3,73.6,-0.91,-1.61,0.7,71.8,22.2,1.55
L550,Severe,1,55.5,-1.55,-1.9,0.35,58,40,0.95
L550,Severe,2,55.8,-1.57,-1.92,0.35,57.5,40.5,0.95
L550,Severe,3,55.6,-1.56,-1.91,0.35,57.8,40.2,0.95`,

  // 4. Chlorophyll & pigment — 5 treatments × 3 stages × 3 reps wheat
  'physio-chlorophyll-pigments': `Treatment_or_Genotype,Growth_stage,Rep,Chlorophyll_a_mg_g_FW,Chlorophyll_b_mg_g_FW,Total_chlorophyll_mg_g_FW,Carotenoids_mg_g_FW,SPAD_value
Control,Tillering,1,2.45,0.95,3.40,0.82,42.5
Control,Tillering,2,2.50,0.98,3.48,0.84,43.1
Control,Tillering,3,2.48,0.96,3.44,0.83,42.8
Control,Booting,1,3.25,1.25,4.50,1.05,48.2
Control,Booting,2,3.30,1.28,4.58,1.07,48.8
Control,Booting,3,3.28,1.26,4.54,1.06,48.5
Control,Grain_fill,1,2.85,1.15,4.00,0.95,45.2
Control,Grain_fill,2,2.90,1.18,4.08,0.97,45.8
Control,Grain_fill,3,2.88,1.16,4.04,0.96,45.5
Drought,Tillering,1,1.85,0.75,2.60,0.65,38.2
Drought,Tillering,2,1.90,0.78,2.68,0.67,38.8
Drought,Tillering,3,1.88,0.76,2.64,0.66,38.5
Drought,Booting,1,2.15,0.88,3.03,0.72,41.2
Drought,Booting,2,2.20,0.91,3.11,0.74,41.8
Drought,Booting,3,2.18,0.89,3.07,0.73,41.5
Drought,Grain_fill,1,1.75,0.72,2.47,0.62,36.8
Drought,Grain_fill,2,1.80,0.75,2.55,0.64,37.4
Drought,Grain_fill,3,1.78,0.73,2.51,0.63,37.1
N_deficient,Tillering,1,1.55,0.62,2.17,0.55,34.5
N_deficient,Tillering,2,1.60,0.65,2.25,0.57,35.1
N_deficient,Tillering,3,1.58,0.63,2.21,0.56,34.8
N_deficient,Booting,1,1.95,0.78,2.73,0.68,38.5
N_deficient,Booting,2,2.00,0.81,2.81,0.70,39.1
N_deficient,Booting,3,1.98,0.79,2.77,0.69,38.8
N_deficient,Grain_fill,1,1.65,0.68,2.33,0.58,35.2
N_deficient,Grain_fill,2,1.70,0.71,2.41,0.60,35.8
N_deficient,Grain_fill,3,1.68,0.69,2.37,0.59,35.5
N_sufficient,Tillering,1,2.85,1.10,3.95,0.92,46.2
N_sufficient,Tillering,2,2.90,1.13,4.03,0.94,46.8
N_sufficient,Tillering,3,2.88,1.11,3.99,0.93,46.5
N_sufficient,Booting,1,3.65,1.40,5.05,1.15,51.2
N_sufficient,Booting,2,3.70,1.43,5.13,1.17,51.8
N_sufficient,Booting,3,3.68,1.41,5.09,1.16,51.5
N_sufficient,Grain_fill,1,3.15,1.28,4.43,1.05,48.2
N_sufficient,Grain_fill,2,3.20,1.31,4.51,1.07,48.8
N_sufficient,Grain_fill,3,3.18,1.29,4.47,1.06,48.5
Biofortified,Tillering,1,2.65,1.00,3.65,0.88,44.5
Biofortified,Tillering,2,2.70,1.03,3.73,0.90,45.1
Biofortified,Tillering,3,2.68,1.01,3.69,0.89,44.8
Biofortified,Booting,1,3.45,1.32,4.77,1.12,50.2
Biofortified,Booting,2,3.50,1.35,4.85,1.14,50.8
Biofortified,Booting,3,3.48,1.33,4.81,1.13,50.5
Biofortified,Grain_fill,1,3.05,1.22,4.27,1.02,47.2
Biofortified,Grain_fill,2,3.10,1.25,4.35,1.04,47.8
Biofortified,Grain_fill,3,3.08,1.23,4.31,1.03,47.5`,

  // 5. Enzyme activity (wide format) — 6 treatments × 3 reps SOD CAT APX GR POD
  'physio-enzyme-activity': `Treatment_or_Genotype,Rep,SOD,CAT,APX,GR,POD
Control,1,125,85,45,28,62
Control,2,128,87,46,29,64
Control,3,126,86,45.5,28.5,63
Drought_mild,1,165,110,62,38,85
Drought_mild,2,168,112,63,39,87
Drought_mild,3,166,111,62.5,38.5,86
Drought_severe,1,215,145,82,52,115
Drought_severe,2,218,148,84,53,118
Drought_severe,3,216,146,83,52.5,116
Heat,1,185,125,72,45,98
Heat,2,188,128,74,46,101
Heat,3,186,126,73,45.5,99
Salinity,1,195,135,78,48,105
Salinity,2,198,138,80,49,108
Salinity,3,196,136,79,48.5,106
Combined_stress,1,245,165,95,62,135
Combined_stress,2,248,168,97,63,138
Combined_stress,3,246,166,96,62.5,136`,

  // 6. Oxidative stress markers — 8 genotypes × 2 conditions (Control/Drought) × 3 reps wheat
  'physio-oxidative-stress': `Treatment_or_Genotype,Stress_level,Rep,MDA_nmol_g_FW,H2O2_umol_g_FW,Proline_ug_g_FW,Total_protein_mg_g_FW,Electrolyte_leakage_percent,Yield
HD2967,Control,1,15.2,3.8,125,28,12,4.85
HD2967,Control,2,15.5,3.9,128,28.5,12.2,4.85
HD2967,Control,3,15.3,3.85,126,28.2,12.1,4.85
HD2967,Drought,1,32.5,8.5,485,24,28,3.85
HD2967,Drought,2,33.2,8.7,495,24.5,28.5,3.85
HD2967,Drought,3,32.8,8.6,488,24.2,28.2,3.85
PBW343,Control,1,16.5,4.2,118,27,13,3.95
PBW343,Control,2,16.8,4.3,120,27.5,13.2,3.95
PBW343,Control,3,16.6,4.25,119,27.2,13.1,3.95
PBW343,Drought,1,42.5,12.2,385,22,38,2.65
PBW343,Drought,2,43.2,12.5,392,22.5,38.5,2.65
PBW343,Drought,3,42.8,12.3,388,22.2,38.2,2.65
DBW17,Control,1,14.2,3.5,130,29.5,11,5.25
DBW17,Control,2,14.5,3.6,132,30,11.2,5.25
DBW17,Control,3,14.3,3.55,131,29.7,11.1,5.25
DBW17,Drought,1,26.5,6.8,585,26,22,4.55
DBW17,Drought,2,27.2,7.0,595,26.5,22.5,4.55
DBW17,Drought,3,26.8,6.9,588,26.2,22.2,4.55
WH1105,Control,1,15.8,4.0,122,27.5,12.5,4.25
WH1105,Control,2,16.1,4.1,124,28,12.7,4.25
WH1105,Control,3,15.9,4.05,123,27.7,12.6,4.25
WH1105,Drought,1,38.5,10.5,425,23,33,3.25
WH1105,Drought,2,39.2,10.8,432,23.5,33.5,3.25
WH1105,Drought,3,38.8,10.6,428,23.2,33.2,3.25
PBW725,Control,1,13.8,3.4,135,30,10.5,5.45
PBW725,Control,2,14.1,3.5,138,30.5,10.7,5.45
PBW725,Control,3,13.9,3.45,136,30.2,10.6,5.45
PBW725,Drought,1,24.5,6.2,625,27,20,4.85
PBW725,Drought,2,25.2,6.4,635,27.5,20.5,4.85
PBW725,Drought,3,24.8,6.3,628,27.2,20.2,4.85
HD3086,Control,1,15.5,3.95,124,28,12.3,4.55
HD3086,Control,2,15.8,4.05,126,28.5,12.5,4.55
HD3086,Control,3,15.6,4.0,125,28.2,12.4,4.55
HD3086,Drought,1,30.5,8.0,515,25,26,3.95
HD3086,Drought,2,31.2,8.2,525,25.5,26.5,3.95
HD3086,Drought,3,30.8,8.1,518,25.2,26.2,3.95
VL907,Control,1,13.5,3.3,138,30.2,10.2,4.65
VL907,Control,2,13.8,3.4,140,30.7,10.4,4.65
VL907,Control,3,13.6,3.35,139,30.4,10.3,4.65
VL907,Drought,1,22.5,5.8,665,28,18,4.25
VL907,Drought,2,23.2,6.0,675,28.5,18.5,4.25
VL907,Drought,3,22.8,5.9,668,28.2,18.2,4.25
NW1014,Control,1,16.2,4.1,120,27.2,12.8,4.15
NW1014,Control,2,16.5,4.2,122,27.7,13.0,4.15
NW1014,Control,3,16.3,4.15,121,27.4,12.9,4.15
NW1014,Drought,1,36.5,9.8,445,23.5,31,3.15
NW1014,Drought,2,37.2,10.1,452,24,31.5,3.15
NW1014,Drought,3,36.8,9.9,448,23.7,31.2,3.15`,

  // 7. Nutritional quality — 15 pearl-millet genotypes × 3 reps
  'physio-nutritional-quality': `Genotype_or_Treatment,Rep,Protein_percent,Iron_ppm,Zinc_ppm,Calcium_ppm,Phosphorus_ppm,Beta_carotene_ug_g,Vitamin_C_mg_100g,Dietary_fibre_percent,Starch_percent,Phytic_acid_mg_100g,Tannin_mg_100g
ICMH1201,1,11.2,65,42,52,285,1.8,2.5,9.5,68.5,850,125
ICMH1201,2,11.4,66,43,53,288,1.85,2.55,9.6,68.7,855,127
ICMH1201,3,11.3,65.5,42.5,52.5,286.5,1.82,2.52,9.55,68.6,852,126
ICMH1301,1,10.8,58,38,48,270,1.5,2.2,8.8,69.2,820,118
ICMH1301,2,11.0,59,39,49,272,1.55,2.25,8.9,69.4,825,120
ICMH1301,3,10.9,58.5,38.5,48.5,271,1.52,2.22,8.85,69.3,822,119
ICMR1004,1,12.5,82,55,62,310,2.5,3.2,10.2,65.8,780,115
ICMR1004,2,12.7,83,56,63,312,2.55,3.25,10.3,66.0,785,117
ICMR1004,3,12.6,82.5,55.5,62.5,311,2.52,3.22,10.25,65.9,782,116
Dhanashakti,1,13.8,95,65,75,325,3.8,4.5,11.8,62.5,750,105
Dhanashakti,2,14.0,96,66,76,328,3.85,4.55,11.9,62.7,755,107
Dhanashakti,3,13.9,95.5,65.5,75.5,326.5,3.82,4.52,11.85,62.6,752,106
ICMH356,1,10.5,55,35,45,265,1.3,2.0,8.5,69.8,825,122
ICMH356,2,10.7,56,36,46,267,1.35,2.05,8.6,70.0,830,124
ICMH356,3,10.6,55.5,35.5,45.5,266,1.32,2.02,8.55,69.9,827,123
HHB67,1,11.8,70,45,55,290,2.0,2.7,9.8,67.5,800,120
HHB67,2,12.0,71,46,56,292,2.05,2.75,9.9,67.7,805,122
HHB67,3,11.9,70.5,45.5,55.5,291,2.02,2.72,9.85,67.6,802,121
AIMP92901,1,11.5,68,44,54,288,1.9,2.6,9.7,68.0,810,123
AIMP92901,2,11.7,69,45,55,290,1.95,2.65,9.8,68.2,815,125
AIMP92901,3,11.6,68.5,44.5,54.5,289,1.92,2.62,9.75,68.1,812,124
HBL11,1,12.2,78,50,60,305,2.3,3.0,10.0,66.2,790,118
HBL11,2,12.4,79,51,61,307,2.35,3.05,10.1,66.4,795,120
HBL11,3,12.3,78.5,50.5,60.5,306,2.32,3.02,10.05,66.3,792,119
Nandi61,1,13.2,88,60,70,318,3.2,4.0,11.2,64.0,770,110
Nandi61,2,13.4,89,61,71,320,3.25,4.05,11.3,64.2,775,112
Nandi61,3,13.3,88.5,60.5,70.5,319,3.22,4.02,11.25,64.1,772,111
GHB538,1,12.0,74,48,58,298,2.2,2.9,10.0,67.0,795,117
GHB538,2,12.2,75,49,59,300,2.25,2.95,10.1,67.2,800,119
GHB538,3,12.1,74.5,48.5,58.5,299,2.22,2.92,10.05,67.1,797,118`,

  // 8. Protein & amino acid — 10 soybean genotypes × 3 reps
  'physio-protein-aa': `Genotype_or_Treatment,Rep,Total_protein_percent,Albumin_mg_g,Globulin_mg_g,Prolamin_mg_g,Glutelin_mg_g,Lysine_g_100g_protein,Methionine_g_100g,Threonine_g_100g,Tryptophan_g_100g
JS335,1,40.2,85,220,35,60,6.2,1.35,3.8,1.25
JS335,2,40.5,86,222,36,61,6.25,1.38,3.85,1.28
JS335,3,40.4,85.5,221,35.5,60.5,6.22,1.36,3.82,1.26
MACS1188,1,42.5,92,240,30,58,6.5,1.45,4.0,1.35
MACS1188,2,42.8,93,242,31,59,6.55,1.48,4.05,1.38
MACS1188,3,42.7,92.5,241,30.5,58.5,6.52,1.46,4.02,1.36
JS9305,1,38.5,78,200,40,65,5.8,1.20,3.5,1.10
JS9305,2,38.8,79,202,41,66,5.85,1.22,3.55,1.12
JS9305,3,38.7,78.5,201,40.5,65.5,5.82,1.21,3.52,1.11
Pusa9712,1,41.2,88,230,32,60,6.3,1.40,3.9,1.30
Pusa9712,2,41.5,89,232,33,61,6.35,1.42,3.95,1.32
Pusa9712,3,41.4,88.5,231,32.5,60.5,6.32,1.41,3.92,1.31
NRC37,1,43.5,95,248,28,56,6.7,1.52,4.15,1.42
NRC37,2,43.8,96,250,29,57,6.75,1.55,4.20,1.45
NRC37,3,43.7,95.5,249,28.5,56.5,6.72,1.53,4.17,1.43
DSb21,1,39.5,82,210,38,62,5.95,1.25,3.65,1.18
DSb21,2,39.8,83,212,39,63,6.00,1.28,3.70,1.20
DSb21,3,39.7,82.5,211,38.5,62.5,5.97,1.26,3.67,1.19
PK472,1,40.8,87,225,34,59,6.25,1.38,3.85,1.27
PK472,2,41.1,88,227,35,60,6.30,1.40,3.90,1.30
PK472,3,41.0,87.5,226,34.5,59.5,6.27,1.39,3.87,1.28
KDS344,1,42.0,90,235,31,57,6.40,1.42,3.95,1.32
KDS344,2,42.3,91,237,32,58,6.45,1.45,4.00,1.35
KDS344,3,42.2,90.5,236,31.5,57.5,6.42,1.43,3.97,1.33
VLS47,1,38.8,80,205,39,64,5.85,1.22,3.55,1.12
VLS47,2,39.1,81,207,40,65,5.90,1.25,3.60,1.15
VLS47,3,39.0,80.5,206,39.5,64.5,5.87,1.23,3.57,1.13
Birsa1,1,40.0,84,218,36,61,6.10,1.30,3.75,1.22
Birsa1,2,40.3,85,220,37,62,6.15,1.32,3.80,1.25
Birsa1,3,40.2,84.5,219,36.5,61.5,6.12,1.31,3.77,1.23`,

  // 9. Oil & fatty acid — 15 mustard genotypes × 3 reps
  'physio-oil-fa': `Genotype_or_Treatment,Rep,Oil_content_percent,Palmitic_C16_0_percent,Stearic_C18_0_percent,Oleic_C18_1_percent,Linoleic_C18_2_percent,Linolenic_C18_3_percent,Erucic_C22_1_percent
Pusa_Bold,1,41.2,3.5,1.8,13.5,14.2,11.5,48.5
Pusa_Bold,2,41.5,3.55,1.82,13.7,14.4,11.6,48.7
Pusa_Bold,3,41.3,3.52,1.81,13.6,14.3,11.55,48.6
RH30,1,38.5,3.8,2.1,12.0,15.5,13.2,46.2
RH30,2,38.8,3.85,2.12,12.2,15.7,13.4,46.4
RH30,3,38.6,3.82,2.11,12.1,15.6,13.3,46.3
NRCHB101,1,42.5,3.2,1.5,62.5,22.5,8.5,0.8
NRCHB101,2,42.8,3.25,1.52,62.8,22.7,8.6,0.82
NRCHB101,3,42.6,3.22,1.51,62.6,22.6,8.55,0.81
PusaJaikisan,1,40.8,3.6,1.9,15.2,16.0,12.0,45.8
PusaJaikisan,2,41.1,3.65,1.92,15.4,16.2,12.1,46.0
PusaJaikisan,3,40.9,3.62,1.91,15.3,16.1,12.05,45.9
PusaMustard30,1,43.2,3.1,1.4,68.5,20.0,7.5,0.5
PusaMustard30,2,43.5,3.15,1.42,68.8,20.2,7.6,0.52
PusaMustard30,3,43.3,3.12,1.41,68.6,20.1,7.55,0.51
Varuna,1,39.5,3.7,2.0,13.0,15.0,12.8,47.2
Varuna,2,39.8,3.75,2.02,13.2,15.2,13.0,47.4
Varuna,3,39.6,3.72,2.01,13.1,15.1,12.9,47.3
Kranti,1,40.2,3.65,1.95,14.0,14.8,12.5,47.0
Kranti,2,40.5,3.70,1.97,14.2,15.0,12.6,47.2
Kranti,3,40.3,3.67,1.96,14.1,14.9,12.55,47.1
PusaMahak,1,42.0,3.3,1.6,58.0,24.5,9.0,1.2
PusaMahak,2,42.3,3.35,1.62,58.3,24.7,9.1,1.22
PusaMahak,3,42.1,3.32,1.61,58.1,24.6,9.05,1.21
RH749,1,39.0,3.8,2.1,12.5,15.5,13.0,46.5
RH749,2,39.3,3.85,2.12,12.7,15.7,13.1,46.7
RH749,3,39.1,3.82,2.11,12.6,15.6,13.05,46.6
JD6,1,40.5,3.6,1.85,13.8,15.2,12.3,47.5
JD6,2,40.8,3.65,1.87,14.0,15.4,12.4,47.7
JD6,3,40.6,3.62,1.86,13.9,15.3,12.35,47.6
PusaDouble0_31_1,1,43.0,3.15,1.45,65.0,21.5,8.0,0.6
PusaDouble0_31_1,2,43.3,3.20,1.47,65.3,21.7,8.1,0.62
PusaDouble0_31_1,3,43.1,3.17,1.46,65.1,21.6,8.05,0.61
RLM619,1,38.8,3.75,2.05,12.8,15.3,12.9,46.8
RLM619,2,39.1,3.80,2.07,13.0,15.5,13.0,47.0
RLM619,3,38.9,3.77,2.06,12.9,15.4,12.95,46.9
GM2,1,40.0,3.68,1.92,13.5,15.1,12.6,47.3
GM2,2,40.3,3.72,1.94,13.7,15.3,12.7,47.5
GM2,3,40.1,3.70,1.93,13.6,15.2,12.65,47.4
CS54,1,41.5,3.5,1.75,14.5,14.0,11.0,48.0
CS54,2,41.8,3.55,1.77,14.7,14.2,11.1,48.2
CS54,3,41.6,3.52,1.76,14.6,14.1,11.05,48.1
NRCDR2,1,42.8,3.2,1.55,60.5,23.0,8.5,1.0
NRCDR2,2,43.1,3.25,1.57,60.8,23.2,8.6,1.02
NRCDR2,3,42.9,3.22,1.56,60.6,23.1,8.55,1.01`,

  // 10. Antioxidant capacity — 12 tomato genotypes × 3 reps
  'physio-antioxidant': `Genotype_or_Treatment,Rep,DPPH_IC50_ug_mL,ABTS_mmol_Trolox_g,FRAP_mmol_Fe_g,Total_phenolics_mg_GAE_g,Total_flavonoids_mg_QE_g,Anthocyanins_mg_100g,Lycopene_ug_g
PusaRuby,1,185,3.2,2.5,4.5,1.2,12,85
PusaRuby,2,188,3.25,2.55,4.6,1.22,12.5,86
PusaRuby,3,186,3.22,2.52,4.55,1.21,12.2,85.5
ArkaVikas,1,125,4.5,3.8,6.2,1.8,18,110
ArkaVikas,2,128,4.55,3.85,6.3,1.82,18.5,112
ArkaVikas,3,126,4.52,3.82,6.25,1.81,18.2,111
PusaEarlyDwarf,1,210,2.8,2.2,3.8,1.0,8,72
PusaEarlyDwarf,2,213,2.85,2.25,3.9,1.02,8.5,74
PusaEarlyDwarf,3,211,2.82,2.22,3.85,1.01,8.2,73
Rashmi,1,98,5.5,4.8,7.8,2.3,28,145
Rashmi,2,100,5.55,4.85,7.9,2.32,28.5,147
Rashmi,3,99,5.52,4.82,7.85,2.31,28.2,146
Sioux,1,165,3.5,2.8,5.0,1.4,14,95
Sioux,2,168,3.55,2.85,5.1,1.42,14.5,97
Sioux,3,166,3.52,2.82,5.05,1.41,14.2,96
ArkaAbha,1,145,4.0,3.2,5.5,1.6,16,105
ArkaAbha,2,148,4.05,3.25,5.6,1.62,16.5,107
ArkaAbha,3,146,4.02,3.22,5.55,1.61,16.2,106
PKM1,1,175,3.3,2.6,4.8,1.3,13,88
PKM1,2,178,3.35,2.65,4.9,1.32,13.5,90
PKM1,3,176,3.32,2.62,4.85,1.31,13.2,89
ArkaSaurabh,1,115,4.8,4.0,6.5,1.9,20,120
ArkaSaurabh,2,118,4.85,4.05,6.6,1.92,20.5,122
ArkaSaurabh,3,116,4.82,4.02,6.55,1.91,20.2,121
PusaHybrid2,1,105,5.2,4.5,7.2,2.1,24,135
PusaHybrid2,2,108,5.25,4.55,7.3,2.12,24.5,137
PusaHybrid2,3,106,5.22,4.52,7.25,2.11,24.2,136
Navodaya,1,155,3.8,3.0,5.3,1.5,15,100
Navodaya,2,158,3.85,3.05,5.4,1.52,15.5,102
Navodaya,3,156,3.82,3.02,5.35,1.51,15.2,101
PKM1_Purple,1,92,5.8,5.0,8.5,2.5,45,155
PKM1_Purple,2,95,5.85,5.05,8.6,2.52,45.5,157
PKM1_Purple,3,93,5.82,5.02,8.55,2.51,45.2,156
IIHR_Chocolate,1,88,6.0,5.3,9.0,2.7,52,165
IIHR_Chocolate,2,90,6.05,5.35,9.1,2.72,52.5,167
IIHR_Chocolate,3,89,6.02,5.32,9.05,2.71,52.2,166`,

  // 11. Hormone analysis — 5 treatments × 3 sampling times × 3 reps (drought)
  'physio-hormones': `Treatment_or_Genotype,Sampling_time,Rep,ABA_ng_g_FW,IAA_ng_g_FW,GA3_ng_g_FW,Cytokinin_ng_g_FW,Jasmonic_acid_ng_g,Salicylic_acid_ug_g
Control,Day_0,1,85,125,65,42,18,0.45
Control,Day_0,2,87,128,66,43,18.5,0.46
Control,Day_0,3,86,126,65.5,42.5,18.2,0.45
Control,Day_7,1,88,122,63,41,19,0.47
Control,Day_7,2,90,125,64,42,19.5,0.48
Control,Day_7,3,89,123,63.5,41.5,19.2,0.47
Control,Day_14,1,90,120,62,40,20,0.48
Control,Day_14,2,92,122,63,41,20.5,0.50
Control,Day_14,3,91,121,62.5,40.5,20.2,0.49
Drought_mild,Day_0,1,86,122,62,40,22,0.55
Drought_mild,Day_0,2,88,125,63,41,22.5,0.57
Drought_mild,Day_0,3,87,123,62.5,40.5,22.2,0.56
Drought_mild,Day_7,1,185,95,40,28,55,1.25
Drought_mild,Day_7,2,188,97,41,29,56,1.28
Drought_mild,Day_7,3,186,96,40.5,28.5,55.5,1.26
Drought_mild,Day_14,1,245,72,32,22,85,1.85
Drought_mild,Day_14,2,248,74,33,23,87,1.88
Drought_mild,Day_14,3,246,73,32.5,22.5,86,1.86
Drought_severe,Day_0,1,88,120,60,38,25,0.60
Drought_severe,Day_0,2,90,122,61,39,25.5,0.62
Drought_severe,Day_0,3,89,121,60.5,38.5,25.2,0.61
Drought_severe,Day_7,1,285,65,28,18,95,2.25
Drought_severe,Day_7,2,288,67,29,19,97,2.28
Drought_severe,Day_7,3,286,66,28.5,18.5,96,2.26
Drought_severe,Day_14,1,385,45,18,12,145,3.25
Drought_severe,Day_14,2,388,47,19,13,147,3.28
Drought_severe,Day_14,3,386,46,18.5,12.5,146,3.26
ABA_primed,Day_0,1,95,118,58,36,30,0.75
ABA_primed,Day_0,2,97,120,59,37,30.5,0.77
ABA_primed,Day_0,3,96,119,58.5,36.5,30.2,0.76
ABA_primed,Day_7,1,145,105,50,32,45,1.05
ABA_primed,Day_7,2,148,107,51,33,46,1.08
ABA_primed,Day_7,3,146,106,50.5,32.5,45.5,1.06
ABA_primed,Day_14,1,185,92,42,28,68,1.45
ABA_primed,Day_14,2,188,94,43,29,70,1.48
ABA_primed,Day_14,3,186,93,42.5,28.5,69,1.46
SA_primed,Day_0,1,86,122,62,40,22,1.85
SA_primed,Day_0,2,88,124,63,41,22.5,1.88
SA_primed,Day_0,3,87,123,62.5,40.5,22.2,1.86
SA_primed,Day_7,1,125,108,52,34,38,2.45
SA_primed,Day_7,2,128,110,53,35,39,2.48
SA_primed,Day_7,3,126,109,52.5,34.5,38.5,2.46
SA_primed,Day_14,1,165,95,45,30,58,3.15
SA_primed,Day_14,2,168,97,46,31,60,3.18
SA_primed,Day_14,3,166,96,45.5,30.5,59,3.16`,

  // 12. Secondary metabolites — 10 mustard genotypes × 3 reps
  'physio-secondary-metabolites': `Genotype_or_Treatment,Rep,Total_alkaloids_mg_g,Tannins_mg_TAE_g,Saponins_percent,Glucosinolates_umol_g,Phytic_acid_mg_100g,Oxalates_mg_100g,Total_phenolics_mg_GAE_g
Varuna,1,0.85,12.5,2.8,105,850,185,5.8
Varuna,2,0.88,12.7,2.85,107,855,187,5.9
Varuna,3,0.86,12.6,2.82,106,852,186,5.85
Kranti,1,0.82,11.8,2.6,98,820,178,5.5
Kranti,2,0.85,12.0,2.65,100,825,180,5.6
Kranti,3,0.83,11.9,2.62,99,822,179,5.55
PusaJaikisan,1,0.90,13.2,3.0,112,880,195,6.2
PusaJaikisan,2,0.93,13.5,3.05,115,885,197,6.3
PusaJaikisan,3,0.91,13.3,3.02,113,882,196,6.25
NRCHB101,1,0.45,6.5,1.8,18,620,125,3.8
NRCHB101,2,0.48,6.8,1.85,19,625,127,3.9
NRCHB101,3,0.46,6.6,1.82,18.5,622,126,3.85
PusaMustard30,1,0.42,6.0,1.7,15,600,118,3.5
PusaMustard30,2,0.45,6.2,1.75,16,605,120,3.6
PusaMustard30,3,0.43,6.1,1.72,15.5,602,119,3.55
PusaDouble0_31_1,1,0.40,5.8,1.65,12,580,115,3.3
PusaDouble0_31_1,2,0.43,6.0,1.70,13,585,117,3.4
PusaDouble0_31_1,3,0.41,5.9,1.67,12.5,582,116,3.35
RH30,1,0.88,12.8,2.9,108,860,188,5.9
RH30,2,0.91,13.0,2.95,110,865,190,6.0
RH30,3,0.89,12.9,2.92,109,862,189,5.95
RLM619,1,0.92,13.5,3.1,118,890,200,6.4
RLM619,2,0.95,13.8,3.15,120,895,202,6.5
RLM619,3,0.93,13.6,3.12,119,892,201,6.45
GM2,1,0.80,11.5,2.5,95,815,175,5.3
GM2,2,0.83,11.8,2.55,97,820,177,5.4
GM2,3,0.81,11.6,2.52,96,817,176,5.35
PusaMahak,1,0.52,8.0,2.0,42,680,140,4.2
PusaMahak,2,0.55,8.2,2.05,44,685,142,4.3
PusaMahak,3,0.53,8.1,2.02,43,682,141,4.25`,

  // 13. Integrated Stress Tolerance — 10 wheat genotypes with combined stress profile
  'physio-integrated-tolerance': `Genotype,Yield_control,Yield_stressed,MDA,H2O2,Electrolyte_leakage,Proline,SOD,CAT,APX
HD2967,4.85,3.85,32.8,8.6,28,488,215,145,82
PBW343,3.95,2.65,42.8,12.3,38,388,168,110,62
DBW17,5.25,4.55,26.8,6.9,22,588,245,165,93
WH1105,4.25,3.25,38.8,10.6,33,428,182,122,72
PBW725,5.45,4.85,24.8,6.3,20,628,265,178,98
HD3086,4.55,3.95,30.8,8.1,26,518,225,152,88
VL907,4.65,4.25,22.8,5.9,18,668,275,185,105
NW1014,4.15,3.15,36.8,9.9,31,448,195,135,78
UP2338,3.85,2.85,44.5,13.5,40,375,158,102,58
K0307,4.45,3.65,34.2,9.2,29,465,205,138,80`,

  // 14. Biofortification Index — 12 pearl-millet / rice genotypes
  'physio-biofortification': `Genotype,Protein_percent,Iron_ppm,Zinc_ppm,Calcium_ppm,Beta_carotene_ug_g,Vitamin_C_mg_100g,Dietary_fibre_percent,Phytic_acid_mg_100g,Tannin_mg_100g
Dhanashakti,13.8,95,65,75,3.8,4.5,11.8,750,105
Nandi61,13.2,88,60,70,3.2,4.0,11.2,770,110
ICMR1004,12.5,82,55,62,2.5,3.2,10.2,780,115
HBL11,12.2,78,50,60,2.3,3.0,10.0,790,118
HHB67,11.8,70,45,55,2.0,2.7,9.8,800,120
AIMP92901,11.5,68,44,54,1.9,2.6,9.7,810,123
ICMH1201,11.2,65,42,52,1.8,2.5,9.5,850,125
ICMH1301,10.8,58,38,48,1.5,2.2,8.8,820,118
ICMH356,10.5,55,35,45,1.3,2.0,8.5,825,122
GHB538,12.0,74,48,58,2.2,2.9,10.0,795,117
Ranbir_Bajra,13.5,92,62,72,3.5,4.2,11.5,760,108
Raj171,11.0,62,40,50,1.6,2.3,9.0,815,121`,

  // 15. Physiology Pipeline — combined wheat dataset (used by pipeline demo)
  'physio-pipeline': `Genotype,Yield_control,Yield_stressed,MDA,H2O2,Proline,SOD,CAT,APX,Electrolyte_leakage
HD2967,4.85,3.85,32.8,8.6,488,215,145,82,28
PBW343,3.95,2.65,42.8,12.3,388,168,110,62,38
DBW17,5.25,4.55,26.8,6.9,588,245,165,93,22
WH1105,4.25,3.25,38.8,10.6,428,182,122,72,33
PBW725,5.45,4.85,24.8,6.3,628,265,178,98,20
HD3086,4.55,3.95,30.8,8.1,518,225,152,88,26
VL907,4.65,4.25,22.8,5.9,668,275,185,105,18
NW1014,4.15,3.15,36.8,9.9,448,195,135,78,31`,
};

export const PHYSIO_SAMPLE_BANNERS = {
  'physio-crop-growth': 'Sample loaded — 4 treatments × 5 sampling dates × 3 reps (wheat biomass + leaf area) — Run Analysis!',
  'physio-photosynthesis': 'Sample loaded — 6 wheat genotypes × 3 growth stages × 3 reps (SPAD + full gas exchange) — Run Analysis!',
  'physio-water-relations': 'Sample loaded — 5 chickpea genotypes × 3 stress levels × 3 reps (RWC, WP, OP, MSI, EL, yield) — Run Analysis!',
  'physio-chlorophyll-pigments': 'Sample loaded — 5 treatments × 3 stages × 3 reps (Chl a/b + carotenoids + SPAD) — Run Analysis!',
  'physio-enzyme-activity': 'Sample loaded — 6 treatments × 3 reps (SOD, CAT, APX, GR, POD wide format) — Run Analysis!',
  'physio-oxidative-stress': 'Sample loaded — 8 wheat genotypes × control vs drought × 3 reps (MDA, H₂O₂, proline, protein, EL, yield) — Run Analysis!',
  'physio-nutritional-quality': 'Sample loaded — 15 pearl-millet genotypes × 3 reps (protein, Fe, Zn, Ca, β-carotene, vitamin C, fibre, phytate, tannin) — Run Analysis!',
  'physio-protein-aa': 'Sample loaded — 10 soybean genotypes × 3 reps (4 protein fractions + 4 essential amino acids) — Run Analysis!',
  'physio-oil-fa': 'Sample loaded — 15 mustard genotypes × 3 reps (oil content + full FA profile C16:0, C18:0, C18:1, C18:2, C18:3, C22:1) — Run Analysis!',
  'physio-antioxidant': 'Sample loaded — 12 tomato genotypes × 3 reps (DPPH, ABTS, FRAP, phenolics, flavonoids, anthocyanins, lycopene) — Run Analysis!',
  'physio-hormones': 'Sample loaded — 5 treatments × 3 sampling times × 3 reps (ABA, IAA, GA₃, cytokinin under drought) — Run Analysis!',
  'physio-secondary-metabolites': 'Sample loaded — 10 mustard genotypes × 3 reps (glucosinolates, tannins, phytic acid, phenolics) — Run Analysis!',
  'physio-integrated-tolerance': 'Sample loaded — 10 wheat genotypes with yield + damage + osmotic + enzyme data — Run to see composite stress tolerance!',
  'physio-biofortification': 'Sample loaded — 12 pearl-millet/rice genotypes — Run to compute ICMR-weighted biofortification index!',
  'physio-pipeline': 'Sample loaded — Combined wheat dataset for pipeline walkthrough — upload this CSV into each step!',
};

/**
 * Published reference ranges for common Indian crops — quick sanity check.
 * Sources compiled from IARI, ICAR & peer-reviewed Indian agricultural journals.
 */
export const PHYSIO_REFERENCE_VALUES = {
  wheat: {
    Chlorophyll_a: '2.5 – 4.5 mg/g FW',
    Chlorophyll_b: '0.8 – 1.6 mg/g FW',
    Total_chlorophyll: '3.3 – 6.0 mg/g FW',
    SPAD: '40 – 55',
    RWC: '85 – 95 % (irrigated); 60 – 75 % (drought)',
    Net_photosynthesis: '18 – 32 µmol CO₂ m⁻² s⁻¹',
    MDA: '10 – 20 nmol/g FW (control); 25 – 45 (stress)',
    Proline: '80 – 150 µg/g FW (control); 400 – 700 (stress)',
    SOD: '120 – 250 U/mg protein',
  },
  rice: {
    Chlorophyll_a: '2.0 – 3.8 mg/g FW',
    Total_chlorophyll: '2.8 – 5.2 mg/g FW',
    SPAD: '35 – 48',
    Net_photosynthesis: '16 – 28 µmol CO₂ m⁻² s⁻¹',
    Proline: '60 – 130 µg/g FW (control)',
  },
  chickpea: {
    RWC: '88 – 94 % (irrigated); 55 – 75 (drought)',
    Leaf_water_potential: '-0.3 to -0.5 MPa (control); -1.2 to -1.8 (drought)',
    MSI: '80 – 90 % (control); 55 – 75 (severe drought)',
    Electrolyte_leakage: '10 – 15 % (control); 25 – 45 (severe stress)',
  },
  pearl_millet: {
    Total_protein: '10 – 14 % grain',
    Iron: '40 – 90 ppm (biofortified up to 110)',
    Zinc: '35 – 65 ppm',
    Beta_carotene: '0.5 – 3.0 µg/g',
  },
  mustard: {
    Oil_content: '38 – 46 %',
    Erucic_acid: '< 2 % (edible lines); 35 – 50 (traditional)',
    Oleic_acid: '12 – 25 % (traditional); 55 – 70 (canola-quality)',
    Glucosinolates: '< 30 µmol/g defatted meal (00 lines)',
  },
  soybean: {
    Oil_content: '18 – 22 %',
    Protein: '38 – 42 %',
    Methionine: '1.2 – 1.5 g/100 g protein',
    Lysine: '5.8 – 6.5 g/100 g protein',
  },
};
